import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Boxes, Fuel, Wallet, Gift } from "lucide-react";
import { FuelReceiptsTab } from "../components/control-room/tabs/FuelReceiptsTab";
import { CompanyOverheadTab } from "../components/control-room/tabs/ExpenseTabs";
import { BenefitsTab } from "../components/control-room/tabs/BenefitsTab";

const TABS = [
  { key: "receipts", label: "Fuel Receipts", icon: Fuel },
  { key: "overhead", label: "Company Overhead", icon: Wallet },
  { key: "benefits", label: "Pogodnosti", icon: Gift },
];

export default function AdminControlRoom() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("receipts");

  if (!localStorage.getItem("juke_admin_token")) {
    navigate("/admin");
    return null;
  }

  return (
    <div data-testid="admin-control-room" className="min-h-screen bg-[#050505] text-zinc-100">
      <div className="border-b border-white/5 bg-black/60 backdrop-blur">
        <div className="max-w-[1400px] mx-auto px-6 py-5 flex items-center gap-4">
          <Link to="/admin/dashboard" className="text-zinc-400 hover:text-white transition" data-testid="cr-back">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="flex-1">
            <div className="flex items-center gap-3">
              <Boxes className="w-5 h-5 text-[#C5A059]" />
              <h1 className="text-xl font-light tracking-wide">Control Room</h1>
              <span className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 border border-white/10 px-2 py-0.5 rounded-full">
                Fuel & Overhead
              </span>
            </div>
            <p className="text-xs text-zinc-500 mt-1">
              Payouts are now driven by Google Sheets — see the dedicated <Link to="/admin/payouts" className="text-[#C5A059] hover:underline">Payouts page</Link>.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 py-6">
        <div className="flex gap-2 mb-5" data-testid="cr-tabs">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className={`px-4 py-2 rounded-full text-sm inline-flex items-center gap-2 transition border ${
                  tab === t.key
                    ? "bg-[#C5A059] text-black border-[#C5A059]"
                    : "border-white/10 text-zinc-400 hover:border-white/30"
                }`}
                data-testid={`cr-tab-${t.key}`}
              >
                <Icon className="w-4 h-4" /> {t.label}
              </button>
            );
          })}
        </div>

        <div className="rounded-2xl border border-white/5 bg-[#0a0a0a] p-6">
          {tab === "receipts" && <FuelReceiptsTab />}
          {tab === "overhead" && <CompanyOverheadTab />}
          {tab === "benefits" && <BenefitsTab />}
        </div>
      </div>
    </div>
  );
}
